import { onMount, onDestroy, onView } from '@/modules/_'

export default function (element, dataset) {
  const items = element.querySelectorAll('[data-bars-vertical="item"]')
  items.forEach((item) => {
    const head = item.querySelector('[data-bars-vertical="head"]')
    const textW = head.querySelectorAll(':scope > *')

    const animate = () => {
      const tl = gsap.timeline()
      tl.fromTo(
        items,
        {
          transformOrigin: '100% 100%',
          scaleY: 0,
        },
        {
          scaleY: 1,
          stagger: 0.1,
          duration: 1,
          ease: 'power2.out',
        }
      )

        .fromTo(
          head,
          {
            transformOrigin: '100% 100%',
            scaleY: 0,
          },
          {
            scaleY: 1,
            stagger: 0.1,
            duration: 1,
            ease: 'power2.out',
          },
          '<0.5'
        )

        .fromTo(
          textW,
          {
            opacity: 0.5,
          },
          {
            opacity: 1,
            duration: 0.5,
            ease: 'none',
          },
          '<0.1'
        )
    }

    onView(element, {
      autoStart: true,
      callback: ({ isIn }) => {
        // console.log("inView", isIn);
        animate()
        if (isIn) {
        }
      },
    })
  })
}
